import { strings } from "../loc/langs";
import avatarTeaMug from "../img/avatars/001-tea.svg";
import avatarBird from "../img/avatars/002-bird.svg";
import avatarPlant from "../img/avatars/003-plant-pot.svg";
import avatarPeach from "../img/avatars/004-peach.svg";
import avatarJoyusBird from "../img/avatars/005-bird-1.svg";
import avatarMonkey from "../img/avatars/006-monkey.svg";
import avatarSunshine from "../img/avatars/007-summertime.svg";

export const activityOptions = (function() {
  const availableActivities = [
    { value: "generic", label: "4", title: `${strings["Activity"]}` },
    { value: "swimming", label: "", title: `${strings["Swimming"]}` },
    { value: "biking", label: "", title: `${strings["Biking"]}` },
    { value: "hiking", label: "", title: `${strings["Hiking"]}` },
    { value: "running", label: "", title: `${strings["Running"]}` },
    { value: "walking", label: "", title: `${strings["Walking"]}` },
    { value: "burning", label: "", title: `${strings["BurningCalories"]}` },
    { value: "chess", label: "", title: `${strings["Chess"]}` },
    { value: "weights", label: "", title: `${strings["Weights"]}` },
    { value: "bball", label: "", title: `${strings["Basketball"]}` },
    { value: "futbol", label: "", title: `${strings["Futbol"]}` },
    { value: "football", label: "", title: `${strings["FootballAmerican"]}` },
    { value: "vball", label: "", title: `${strings["Volleyball"]}` },
    { value: "pingpong", label: "", title: `${strings["Ping Pong"]}` },
    { value: "beach", label: "", title: `${strings["Beach"]}` }
  ];

  // Get the activities from the stopwatch context which is passed in from SharePoint.
  // Returns in comma delimited format, ex: "bike,vball,bball".
  let selectedActivities =
    window["_stopwatchContextInfo"]["selectedActivityIcons"];
  // Convert to array.
  let arrSelectedActivities = selectedActivities.split(", ");

  if (arrSelectedActivities.length === 0 || arrSelectedActivities[0] == "") {
    arrSelectedActivities.push("generic");
  }

  // Return a filtered array of available activities.
  let filteredAvailableActivities = availableActivities.filter(function(item) {
    return arrSelectedActivities.includes(item.value);
  });

  // Return the filtered activities or all avtivities if there are no filtered activities.
  return filteredAvailableActivities.length !== 0
    ? filteredAvailableActivities
    : availableActivities;
})();

export const intensityOptions = [
  { value: "low", label: "", title: `${strings["LowIntensity"]}` },
  { value: "high", label: "", title: `${strings["HighIntensity"]}` }
];

export const avatarOptions = [
  { value: "tea mug", label: `${avatarTeaMug}` },
  { value: "bird", label: `${avatarBird}` },
  { value: "plant", label: `${avatarPlant}` },
  { value: "peach", label: `${avatarPeach}` },
  { value: "joyusbird", label: `${avatarJoyusBird}` },
  { value: "monkey", label: `${avatarMonkey}` },
  { value: "sunshine", label: `${avatarSunshine}` }
];
